import type { WorkspaceBillingContract } from '@nest-react/domain';

type Subscription = WorkspaceBillingContract['subscription'];

export const hasActivePaidSubscription = (
  subscription: Subscription,
  now = Date.now()
): boolean => {
  if (subscription.plan === 'FREE') return false;
  const end = subscription.paidThroughAt ?? subscription.currentPeriodEnd;
  if (end) return new Date(end).getTime() > now;
  return subscription.status === 'ACTIVE';
};

export const hasExpiredPaidSubscription = (
  subscription: Subscription,
  now = Date.now()
): boolean =>
  subscription.plan !== 'FREE' && !hasActivePaidSubscription(subscription, now);

export const generationBillingFailure = (
  message: string
): 'subscription' | 'credits' | null => {
  if (/insufficient credits/i.test(message)) return 'credits';
  if (
    /requires? (?:an? )?(?:active )?paid plan|requires? (?:Pro|Standard|Max)|subscription (?:has )?expired/i.test(
      message
    )
  )
    return 'subscription';
  return null;
};
